<template>
	<div>
		<section class="content">
			<div class="row">
				<div class="col-sm-12">
					<div class="box box-primary">
						<div class="box-header with-border">
							<h3 class="box-title">Ações do formulário</h3>
							<div class="box-tools pull-right">
								<button
									class="btn-sm btn btn-default"
									@click="back"
								>
									<i class="fa fa-arrow-left"></i>
									Voltar
								</button>
							</div>
						</div>
						<div class="box-body">
							<b>Tipo</b>
							<span
								v-if="chForm.settings.type == 'ao_iniciar'"
								class="label label-md label-info"
							>
								Ao Iniciar
							</span>
							<span
								v-if="chForm.settings.type == 'ao_avancar'"
								class="label label-md label-primary"
							>
								Ao Avançar Ciclo
							</span>
							<span
								v-if="chForm.settings.type == 'ao_finalizar'"
								class="label label-md label-success"
							>
								Ao Finalizar
							</span>

							<span
								v-if="chForm.settings.type == 'ao_exceder'"
								class="label label-md label-warning"
							>
								Ao Exceder Ciclos
							</span>
							<div class="clearfix"></div>
							<br />

							<div class="row">
								<!-- Impressao -->
								<div class="col-sm-6">
									<b>
										Opções de impressão
										<small class="description pull-right">
											<i class="icon fa fa-info"></i>
											Relativas ao botão de Imprimir
										</small>
										<hr style="margin-top: 0px" />
									</b>

									<div class="col-sm-12">
										<span>Template</span>
										<select
											class="form-control"
											:disabled="
												!chForm.settings.printButton
											"
											v-model="chForm.settings.printInfo"
										>
											<option value="">Escolher</option>
											<option
												v-for="(temp, index) in templates"
												:key="index"
												:value="temp.cod"
											>
												{{ temp.titulo }}
											</option>
										</select>
									</div>
								</div>

								<!-- Cancelamento -->
								<div class="col-sm-6">
									<b>
										Opções de cancelamento
										<small class="description pull-right">
											<i class="icon fa fa-info"></i>
											Relativas ao botão de cancelar
										</small>
										<hr style="margin-top: 0px" />
									</b>

									<div class="col-sm-12">
										<span>Açõa ao cancelar</span>
										<div class="well well-sm">
											<div class="radio-inline">
												<label>
													<input
														:disabled="
															!chForm.settings
																.cancelButton
														"
														v-model="chForm.settings.CancelInfo"
														type="radio"
														value="cancel"
													/>
													<span>Apenas cancelar</span>
												</label>
											</div>
											<div class="radio-inline">
												<label>
													<input
														:disabled="
															!chForm.settings
																.cancelButton
														"
														v-model="chForm.settings.CancelInfo"
														type="radio"
														value="cancelandnextcycle"
													/>
													<span
														>Cancelar e avançar
														ciclo</span
													>
												</label>
											</div>
										</div>
										<br />
									</div>
								</div>

								<div class="clearfix"></div>

								<!-- Armazenamento -->
								<div class="col-sm-6">
									<b>
										Opções de arazenamento
										<small class="description pull-right">
											<i class="icon fa fa-info"></i>
											Relativas ao botão de Salvar
										</small>
										<hr style="margin-top: 0px" />
									</b>

									<div class="col-sm-12">
										<div class="radio-inline">
											<label>
												<input
													:disabled="
														!chForm.settings
															.saveButton
													"
													v-model="chForm.settings.saveInfo.type"
													type="radio"
													value="virtualTable"
												/>
												<span>Na O.S.</span>
											</label>
										</div>
										<div class="radio-inline">
											<label>
												<input
													:disabled="
														!chForm.settings
															.saveButton
													"
													v-model="chForm.settings.saveInfo.type"
													type="radio"
													value="dataBase"
												/>
												<span>Na Smart Tables</span>
											</label>
										</div>
									</div>

									<div
										v-if="
											chForm.settings.saveInfo.type ==
											'virtualTable'
										"
										class="col-sm-12"
									>
										<br />
										<div class="callout callout-info">
											<h4>
												<i class="icon fa fa-info"></i>
												Atenção
											</h4>
											<p>
												O conteúdo do formulário será
												salvo dentro da ordem de serviço
												e só poderá ser acessado pelos
												usuários que tiverem acesso a
												O.S. em questão
											</p>
										</div>
									</div>
									<div v-else>
										<div class="col-sm-12">
											<br />
											<span>Associar há</span>
											<!-- <input type="text" class="form-control"
												:disabled='!chForm.settings.saveButton'
												v-model='chForm.settings.saveInfo.dataBase'> -->

											<select
												class="form-control"
												:disabled="
													!chForm.settings.saveButton
												"
												v-model="chForm.settings.saveInfo.dataBase"
											>
												<option value="">
													Escolher
												</option>
												<option
													v-for="sTab in $parent.sTables"
													:value="sTab.cod"
													:key="sTab"
												>
													{{ sTab.titulo }}
												</option>
											</select>
										</div>
										<div class="col-sm-12">
											<br />
											<div
												class="callout callout-warning"
											>
												<h4>
													<i
														class="icon fa fa-info"
													></i>
													Atenção
												</h4>
												<p>
													O conteúdo do formulário
													será armazenado em
													SmartTables podendo ser
													consultado em
													<router-link
														to="/tables/create"
														>SmartTable</router-link
													>; Indicado para formulários
													cujo as informações poderam
													gerar relatórios
													posteriormente...
												</p>
											</div>
										</div>
									</div>
								</div>

								<!-- Enviar Email -->
								<div class="col-sm-6">
									<b>
										Opções de email
										<small class="description pull-right">
											<i class="icon fa fa-info"></i>
											Relativas ao botão de enviar email
										</small>
										<hr style="margin-top: 0px" />
									</b>
									<div class="col-sm-12">
										<span>Template</span>
										<select
											class="form-control"
											:disabled="
												!chForm.settings.mailButton
											"
											v-model="chForm.settings.emailInfos.template"
										>
											<option value="">Escolher</option>
											<option value="msgDef">
												Mensagem definida
											</option>
											<option
												v-for="(temp, index) in templates"
												:key="index"
												:value="temp.cod"
											>
												{{ temp.titulo }}
											</option>
										</select>
									</div>

									<div class="col-sm-6">
										<span>De</span>
										<input
											type="text"
											class="form-control"
											:disabled="
												!chForm.settings.mailButton
											"
											v-model="chForm.settings.emailInfos.de"
										/>
									</div>

									<div class="col-sm-6">
										<span>Para</span>
										<select
											class="form-control"
											v-model="chForm.settings.emailInfos.paraOpt"
											:disabled="
												!chForm.settings.mailButton
											"
										>
											<option value="">Escolher</option>
											<option value="etatico">
												Email estático
											</option>
											<option value="cliente">
												Cliente do contrato
											</option>
											<option value="gestor">
												Gestor do contrato
											</option>
											<option
												v-for="inp in getData()"
												:value="inp.input"
												:key="inp"
											>
												Campo: {{ inp.label }}
											</option>
										</select>
									</div>

									<div class="col-sm-6">
										<span>Cópia de segurança</span>
										<input
											type="text"
											class="form-control"
											:disabled="
												!chForm.settings.mailButton
											"
											v-model="chForm.settings.emailInfos.cc"
										/>
									</div>

									<!-- <pre>{{getData()}}</pre> -->

									<div class="col-sm-6">
										<span>Email</span>
										<input
											type="text"
											class="form-control"
											:disabled="
												!chForm.settings.mailButton ||
												chForm.settings.emailInfos
													.paraOpt != 'etatico'
											"
											v-model="chForm.settings.emailInfos.emailEstatico"
										/>
									</div>

									<div
										v-if="
											chForm.settings.emailInfos
												.template == 'msgDef'
										"
										class="col-sm-12"
									>
										<span>Titulo do email</span>
										<input
											type="text"
											class="form-control"
											:disabled="
												!chForm.settings.mailButton
											"
											v-model="chForm.settings.emailInfos.titulo"
										/>
									</div>
									<div
										v-if="
											chForm.settings.emailInfos
												.template == 'msgDef'
										"
										class="col-sm-12"
									>
										<span>Corpo do email</span>
										<textarea
											class="form-control"
											rows="7"
											:disabled="
												!chForm.settings.mailButton
											"
											v-model="chForm.settings.emailInfos.body"
										></textarea>
									</div>
								</div>
							</div>

							<div class="clearfix"></div>
							<br />
						</div>
						<div class="box-footer">
							<div class="pull-right">
								<button
									class="btn btn-success btn-lg"
									@click="saveForm"
								>
									<i class="fa fa-save"></i>
									Salvar formulário
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <pre>{{chForm}}</pre> -->
	</div>
</template>
<script>
	import clone from 'js/clone';
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		name: 'EndForm',
		props: ['data', 'step'],
		data() {
			return {
				templates: [],
			};
		},
		computed: {
			chForm() {
				return this.data;
			},
		},
		methods: {
			back() {
				this.$emit('backStep');
			},
			getData() {
				let resp = [];
				this.chForm.inputs.forEach((item) => {
					if (item.type != 'msg') {
						let val = item.value;
						if (item.value == '') val = 'Não definido';
						resp.push({
							input: item.id,
							value: val,
							label: item.label,
						});
					}
				});
				return resp;
			},
			saveForm() {
				let sData = clone(this.chForm);
				let cod = this.$route.params.cod_tarefa;

				//agrupando as informações
				sData.data = this.getData();

				//limpando as opçoes
				sData.inputs.forEach((item) => {
					if (item.options.type == 'table-db') {
						delete item.options.options;
					}
				});

				WBS.send(
					'private-save-forms',
					{ data: sData, cod_tarefa: cod },
					(data) => {
						if (data.status == 'success') {
							toastr.success('Formulário salvo com sucesso!');
							this.$router.push({ path: '/forms' });
						} else {
							toastr.error('Erro ao salvar formulário!');
							console.log(data);
						}
					}
				);
			},
		},
		mounted() {
			WBS.send('protected-read-asstesContractsSST', (resp) => {
				if (resp.status == 'success') {
					this.templates = resp.data.tmp;
				}
			});
		},
	};
</script>
<style scoped>
	.description {
		color: #9a9a9a;
		font-weight: 100;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/components/end-form.vue